import { inject, Injectable } from '@angular/core';
import { BranchReferringParams } from 'capacitor-branch-deep-links';
import { filter, Observable, of } from 'rxjs';
import { CampaignService } from '../services/campaign.service';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class CampaignSandbox {
  private campaignService = inject(CampaignService);
  private router = inject(Router);
  private localStorageKey = 'campaign';

  checkCampaign(referringParams: BranchReferringParams, authenticated: boolean): Observable<string> {
    if (referringParams['campaignId']) {
      const dataObject = Object.keys(referringParams)
        .filter((key) => /^[a-zA-Z]+$/.test(key))
        .reduce((obj, key) => {
          obj[key] = referringParams[key];
          return obj;
        }, {});

      if (authenticated) {
        return this.campaignService.startCampaign(dataObject);
      }

      localStorage.setItem(this.localStorageKey, JSON.stringify(dataObject));
    }
    return of('');
  }

  checkCampaignInLocalStorage(): void {
    const data = JSON.parse(localStorage.getItem(this.localStorageKey));
    if (data) {
      this.campaignService
        .startCampaign(data)
        .pipe(
          filter((routeUrl: string) => routeUrl && routeUrl.length > 0)
        )
        .subscribe((routeUrl: string) => {
          localStorage.removeItem(this.localStorageKey);
          this.router.navigateByUrl(routeUrl, { replaceUrl: true });
        });
    }
  }
}
